import { businessKey } from 'queryKeys';

const screenQuery = businessKey.query('ai-chatbot');

const messagesQuery = screenQuery.query('messages');
export const chatsListQuery = screenQuery.query('chats');

export const messages = messagesQuery.exact('list');
export const chat = chatsListQuery.details();
export const chats = chatsListQuery.all();

export const messageMutations = messagesQuery.mutations();
export const chatMutations = chatsListQuery.mutations();

export const updateChat = chatMutations.update();
export const deleteChat = chatMutations.delete();
export const feedbackChat = chatMutations.mutate('feedback');
export const markMessage = messageMutations.mutate('mark');
export const submitMessage = messageMutations.mutate('submit');
